
import Button from "@/components/base/Button"
import StoreInvoiceCard from "@/components/store/StoreInvoiceCard"
import { mdiClose } from "@mdi/js"
export default {
    name: "InvoiceFabCard",
    components: { StoreInvoiceCard, Button },
    data: () => ({
        isInvoiceExtended: false,
        wasClicked: false,
        wasViewed: false,
        viewTimeout: null,
    }),
    icons: {
        mdiClose,
    },
    inject: ["shoppingCart"],
    computed: {
        internalCart() {
            return this.shoppingCart()
        },
    },
    watch: {
        internalCart(newVal) {
            if (newVal && !this.wasViewed) {
                this.isInvoiceExtended = true
                this.viewTimeout = setTimeout(() => {
                    this.isInvoiceExtended = false
                    this.wasViewed = true
                }, 4000)
            }
        },
    },
    methods: {
        onClickOutside() {
            if (this.isInvoiceExtended) {
                if (this.viewTimeout) {
                    clearTimeout(this.viewTimeout)
                    this.viewTimeout = null
                    this.wasViewed = true
                }
                this.isInvoiceExtended = false
            }
        },
        onBtnClick() {
            this.isInvoiceExtended = true
            this.wasViewed = true
            this.wasClicked = true
        },
    },
}
